import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Leftmenu from './Leftmenu';
import { Link, useLocation } from 'react-router-dom';
import API_BASE_URL from "../Config";
import { toast } from "react-toastify";
import "./styles/Header.css";
import "../styles/global.css";

const Header = () => {

  const toggleSidebar = () => {
    const width = window.innerWidth;
    if (width >= 992) {
      const sidebar = document.documentElement.getAttribute("data-sidebar");
      if (sidebar === "small") {
        document.documentElement.setAttribute("data-sidebar", "default");
      } else {
        document.documentElement.setAttribute("data-sidebar", "small");
      }
    } else {
      document.body.classList.toggle("sidebar-enable");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("config_id");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user");
    localStorage.removeItem("name");
    localStorage.removeItem("role");
    toast.success(" Logout Successfully");
    setTimeout(() => {
      navigate("/", { replace: true });
    }, 100);
    // OR clear all if no other data is needed
    // localStorage.clear();
  };

  const navigate = useNavigate();
  const [displayName, setdisplayName] = useState(null);
  var company_name = localStorage.getItem('company_name');
  useEffect(() => {
    setdisplayName(company_name);
  }, []);

  // ── Profile dropdown state ──
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

//      const handleLogout = async () => {
//     const token = localStorage.getItem("authToken");

//     try {
//       const response = await fetch(`${API_BASE_URL}logout`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = await response.json();

//       if (data.status) {
//         // ✅ clear token
//         localStorage.removeItem("authToken");
//         alert("Logged out successfully!");
//         navigate("/login"); // redirect to login
//       } else {
//         alert("Logout failed, please try again!");
//       }
//     } catch (error) {
//       console.error("Logout error:", error);
//       alert("Something went wrong during logout!");
//     }
//   };

  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header">

          <div className="navbar-logo-box">
            <Link to="/dashboard" className="logo logo-dark">
              <span className="logo-sm">
                <img src="assets/images/logo-sm.png" alt="logo-sm-dark" height="22" />
              </span>
              <span className="logo-lg">
                <img src="assets/images/logo-dark.png" alt="logo-dark" height="20" />
              </span>
            </Link>
            <Link to="/dashboard" className="logo logo-light">
              <span className="logo-sm">
                <img src="assets/images/logo-sm.png" alt="logo-sm-light" height="22" />
              </span>
              <span className="logo-lg">
                <img src="assets/images/logo-light.png" alt="logo-light" height="20" />
              </span>
            </Link>
            <button type="button" className="btn btn-icon top-icon sidebar-btn" id="sidebar-btn" onClick={toggleSidebar} aria-label="Toggle navigation">
              <i className="mdi mdi-format-list-bulleted align-middle fs-17"></i>
            </button>
            <button type="button" className="btn btn-icon top-icon sidebar-horizontal-btn d-none" aria-label="Toggle navigation">
              <i className="mdi mdi-menu align-middle fs-17"></i>
            </button>
          </div>

          <div className="d-flex justify-content-between menu-sm px-4 ms-auto">
            <div className="d-flex align-items-center gap-2"></div>
            <div className="d-flex align-items-center gap-3">
              {/* REMOVED: search form */}

              <div className="d-inline-block activities">
                <button type="button" aria-label="activities" className="btn btn-icon top-icon" data-bs-toggle="offcanvas" data-bs-target="#offcanvas-rightsidabar">
                  <i className="mdi mdi-table align-middle fs-17"></i>
                </button>
              </div>

              <button type="button" onClick={handleLogout} className="btn btn-icon top-icon d-none d-md-block" id="light-dark-mode" aria-label="Toggle Light/Dark">
                <i className="mdi mdi-logout align-middle"></i>
              </button>

              <div className="dropdown d-inline-block">
                <button type="button" className="btn btn-icon top-icon" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Notifications">
                  <i className="mdi mdi-bell-ring-outline fs-17"></i>
                </button>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-md dropdown-menu-end dropdown-menu-animated p-0" aria-labelledby="page-header-notifications-dropdown">
                  <div className="p-4 border-bottom">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="m-0"><i className="mdi mdi-bell-ring-outline me-1 fs-15"></i> Notifications</h6>
                      </div>
                      <div className="col-auto">
                        <a href="#!" className="badge bg-info-subtle text-info"> 8+</a>
                      </div>
                    </div>
                  </div>
                  <div data-simplebar style={{ maxHeight: "230px" }}>
                    <a href="#!" className="text-reset notification-item">
                      <div className="d-flex">
                        <div className="avatar avatar-xs avatar-label-primary me-3"><span className="rounded fs-16"><i className="mdi mdi-file-document-outline"></i></span></div>
                        <div className="flex-1"><h6 className="mb-1">New report has been recived</h6><p className="mb-0 fs-12 text-muted"><i className="mdi mdi-clock-outline"></i> 3 min ago</p></div>
                        <i className="mdi mdi-chevron-right align-middle ms-2"></i>
                      </div>
                    </a>
                    <a href="#!" className="text-reset notification-item">
                      <div className="d-flex">
                        <div className="avatar avatar-xs avatar-label-success me-3"><span className="rounded fs-16"><i className="mdi mdi-cart-variant"></i></span></div>
                        <div className="flex-1"><h6 className="mb-1">Last order was completed</h6><p className="mb-0 fs-12 text-muted"><i className="mdi mdi-clock-outline"></i> 1 hour ago</p></div>
                        <i className="mdi mdi-chevron-right align-middle ms-2"></i>
                      </div>
                    </a>
                    <a href="#!" className="text-reset notification-item">
                      <div className="d-flex">
                        <div className="avatar avatar-xs avatar-label-danger me-3"><span className="rounded fs-16"><i className="mdi mdi-account-group"></i></span></div>
                        <div className="flex-1"><h6 className="mb-1">Completed meeting canceled</h6><p className="mb-0 fs-12 text-muted"><i className="mdi mdi-clock-outline"></i> 5 hour ago</p></div>
                        <i className="mdi mdi-chevron-right align-middle ms-2"></i>
                      </div>
                    </a>
                    <a href="#!" className="text-reset notification-item">
                      <div className="d-flex">
                        <div className="avatar avatar-xs avatar-label-warning me-3"><span className="rounded fs-16"><i className="mdi mdi-send-outline"></i></span></div>
                        <div className="flex-1"><h6 className="mb-1">New feedback received</h6><p className="mb-0 fs-12 text-muted"><i className="mdi mdi-clock-outline"></i> 6 hour ago</p></div>
                        <i className="mdi mdi-chevron-right align-middle ms-2"></i>
                      </div>
                    </a>
                    <a href="#!" className="text-reset notification-item">
                      <div className="d-flex">
                        <div className="avatar avatar-xs avatar-label-secondary me-3"><span className="rounded fs-16"><i className="mdi mdi-download-box"></i></span></div>
                        <div className="flex-1"><h6 className="mb-1">New update was available</h6><p className="mb-0 fs-12 text-muted"><i className="mdi mdi-clock-outline"></i> 1 day ago</p></div>
                        <i className="mdi mdi-chevron-right align-middle ms-2"></i>
                      </div>
                    </a>
                    <a href="#!" className="text-reset notification-item">
                      <div className="d-flex">
                        <div className="avatar avatar-xs avatar-label-info me-3"><span className="rounded fs-16"><i className="mdi mdi-hexagram-outline"></i></span></div>
                        <div className="flex-1"><h6 className="mb-1">Your password was changed</h6><p className="mb-0 fs-12 text-muted"><i className="mdi mdi-clock-outline"></i> 2 day ago</p></div>
                        <i className="mdi mdi-chevron-right align-middle ms-2"></i>
                      </div>
                    </a>
                  </div>
                  <div className="p-2 border-top">
                    <div className="d-grid">
                      <a className="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
                        <i className="mdi mdi-arrow-right-circle me-1"></i> View More..
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* ══ PROFILE DROPDOWN — React controlled ══ */}
              <div
                className="d-inline-block ps-3 ms-2 border-start admin-user-info"
                style={{ position: 'relative' }}
                ref={profileRef}
              >
                {/* Trigger */}
                <button
                  type="button"
                  aria-label="profile"
                  className="pd-trigger"
                  onClick={() => setProfileOpen(prev => !prev)}
                >
                  <span className="pd-trigger-avatar">
                    {displayName ? displayName.charAt(0).toUpperCase() : 'A'}
                  </span>
                  <span className="d-none d-xl-flex flex-column align-items-start" style={{ lineHeight: 1.25 }}>
                    <span className="fw-semibold fs-14">{displayName || 'Admin'}</span>
                    <span className="text-muted" style={{ fontSize: 11 }}>Administrator</span>
                  </span>
                  <i className="mdi mdi-chevron-down align-middle fs-16 d-none d-xl-inline-block ms-1"></i>
                </button>

                {/* Dropdown panel */}
                {profileOpen && (
                  <div className="profile-dropdown-menu">
                    {/* Header */}
                    <div className="pd-header">
                      <div className="pd-avatar">
                        {displayName ? displayName.charAt(0).toUpperCase() : 'A'}
                      </div>
                      <div style={{ overflow: 'hidden' }}>
                        <div className="pd-name">{displayName || 'Admin'}</div>
                        <div className="pd-email">admin@myherbalbasket.com</div>
                      </div>
                    </div>

                    {/* Items */}
                    <div className="pd-body">
                      <Link
                        to="/settings/1"
                        className="pd-item"
                        onClick={() => setProfileOpen(false)}
                      >
                        <i className="mdi mdi-cog-outline"></i>
                        <span>Settings</span>
                      </Link>

                      <hr className="pd-divider" />

                      <button
                        className="pd-item pd-logout"
                        onClick={() => { setProfileOpen(false); handleLogout(); }}
                      >
                        <i className="mdi mdi-logout"></i>
                        <span>Logout</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {/* ══ END PROFILE DROPDOWN ══ */}

            </div>
          </div>
        </div>
      </header>
      <Leftmenu />
    </>
  );
};
window.scrollTo(0, 0);

export default Header;